import { render, staticRenderFns } from "./HelperBg.vue?vue&type=template&id=50fd270b&scoped=true"
import script from "./HelperBg.vue?vue&type=script&lang=js"
export * from "./HelperBg.vue?vue&type=script&lang=js"
import style0 from "./HelperBg.vue?vue&type=style&index=0&id=50fd270b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50fd270b",
  null
  
)

export default component.exports